/**
 * 业绩记录服务
 */

import axios from 'axios';
import { PerformanceRecord, DepartmentPerformanceSummary, PerformanceStatistics, DepartmentPerformanceDetail } from './types';
import { getListResponse, API_BASE } from './utils';

export const performanceRecordService = {
    list: async (params?: { period_id?: number; department_id?: number; dimension_id?: number }): Promise<PerformanceRecord[]> => {
        const response = await axios.get(`${API_BASE}/performance-records/`, { params });
        return getListResponse(response.data);
    },

    get: async (id: number): Promise<PerformanceRecord> => {
        const response = await axios.get(`${API_BASE}/performance-records/${id}/`);
        return response.data;
    },

    create: async (data: Partial<PerformanceRecord>): Promise<PerformanceRecord> => {
        const response = await axios.post(`${API_BASE}/performance-records/`, data);
        return response.data;
    },

    update: async (id: number, data: Partial<PerformanceRecord>): Promise<PerformanceRecord> => {
        const response = await axios.patch(`${API_BASE}/performance-records/${id}/`, data);
        return response.data;
    },

    delete: async (id: number): Promise<void> => {
        await axios.delete(`${API_BASE}/performance-records/${id}/`);
    },

    batchCreate: async (periodId: number, departmentId: number, records: any[]): Promise<{ message: string; data: PerformanceRecord[] }> => {
        const response = await axios.post(`${API_BASE}/performance-records/batch_create/`, {
            period_id: periodId,
            department_id: departmentId,
            records,
        });
        return response.data;
    },
};

export const performanceSummaryService = {
    list: async (params?: { period_id?: number; department_id?: number }): Promise<DepartmentPerformanceSummary[]> => {
        const response = await axios.get(`${API_BASE}/performance-summaries/`, { params });
        return getListResponse(response.data);
    },

    getStatistics: async (periodId?: number): Promise<PerformanceStatistics> => {
        const response = await axios.get(`${API_BASE}/performance-summaries/statistics/`, {
            params: { period_id: periodId },
        });
        return response.data;
    },

    getDepartmentDetail: async (periodId: number, departmentId: number): Promise<DepartmentPerformanceDetail> => {
        const response = await axios.get(`${API_BASE}/performance-summaries/department_detail/`, {
            params: { period_id: periodId, department_id: departmentId },
        });
        return response.data;
    },
};
